module.exports = __webpack_public_path__ + "static/img/queenTi_coupon_new.049a4a8.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/couponsys/assets/images/queenTi/queenTi_coupon_new.png
// module id = ZcIl
// module chunks = 0